import { Routes } from '@angular/router';
import { TypeSelection } from './pages/type-selection/type-selection';
import { PriceForm } from './pages/price-form/price-form';
import { PriceResult } from './pages/price-result/price-result';
import { ProductForm } from './pages/product-form/product-form';
import { ContractForm } from './pages/contract-form/contract-form';
import { PaymentResult } from './pages/payment-result/payment-result';
import { ContractPreview } from './pages/contract-preview/contract-preview';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: TypeSelection,
  },
  {
    path: 'price-form/:type',
    component: PriceForm,
  },
  {
    path: 'price-result',
    component: PriceResult,
  },
  {
    path: 'product-form',
    component: ProductForm,
  },
  {
    path: 'contract-form',
    component: ContractForm,
  },
  {
    path: 'contract-preview',
    component: ContractPreview,
  },
  {
    path: 'payment-ok',
    component: PaymentResult,
    data: { result: 'ok' },
  },
  {
    path: 'payment-ko',
    component: PaymentResult,
    data: { result: 'ko' },
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];
